import { Plugin } from 'ckeditor5';
import { OrcaPlaceholderSchema } from './OrcaPlaceholderSchema';
import { PlaceholderStore } from './store';
import { PlaceholderToolbar } from './toolbar';
import { PlaceholderWidget } from './widget';
/**
 * This plugin adds support for rendering placeholders in the Orca editor.
 */
export class OrcaPlaceholders extends Plugin {
    static get pluginName() {
        return 'Placeholders';
    }
    static get requires() {
        return [PlaceholderStore, OrcaPlaceholderSchema, PlaceholderToolbar, PlaceholderWidget];
    }
}
